var provinces = [
    {
        "label": "Alberta",
        "val": "AB"
    },
    {
        "label": "British Columbia",
        "val": "BC"
    },
    {
        "label": "Manitoba",
        "val": "MB"
    },
    {
        "label": "New Brunswick",
        "val": "NB"
    },
    {
        "label": "Newfoundland and Labrador",
        "val": "NL"
    },
    {
        "label": "Northwest Territories",
        "val": "NT"
    },
    {
        "label": "Nova Scotia",
        "val": "NS"
    },
    {
        "label": "Nunavut",
        "val": "NU"
    },
    {
        "label": "Ontario",
        "val": "ON"
    },
    {
        "label": "Prince Edward Island",
        "val": "PE"
    },
    {
        "label": "Quebec",
        "val": "QC"
    },
    {
        "label": "Saskatchewan",
        "val": "SK"
    },
    {
        "label": "Yukon",
        "val": "YT"
    }
]

module.exports = provinces;